export const DATE_SHORT = 'MM/dd/yyyy';
export const DATE_MEDIUM = 'MMM d, yyyy';
export const DATE_TIME_MEDIUM = 'MMM d, yyyy · h:mm a';
